// extracted by mini-css-extract-plugin
export default {"main":"jEIFYl-+W3B9JPZvmmQhrw=="};